import React from 'react';
import ImgBubbleFooter from './imgBubbleFooter';
import styles from './imgBubbleGuide.module.scss';
const ImgBubbleGuideContent = props => {
    const { title, intro = '', renderFooter, guideId, step, onStep, okText, contentImg, onClose } = props;
    return (React.createElement("div", { className: styles.guideBobble },
        contentImg && React.createElement("p", { className: styles.contentImg, style: { backgroundImage: `url(${contentImg})` } }),
        React.createElement("p", { className: styles.title }, title),
        typeof intro === 'string' ? (React.createElement("p", { className: styles.intro, hidden: !intro }, intro)) : (intro),
        renderFooter ? renderFooter : React.createElement(ImgBubbleFooter, Object.assign({}, { guideId, step, onStep, okText, onClose }))));
};
export default ImgBubbleGuideContent;
